import {Component, OnInit} from '@angular/core';
import {CurrentUserService} from '../../../user/services/current-user/current-user.service';
import {Location} from '@angular/common';
import {AuthService} from '../../../user/services/auth/auth.service';

@Component({
  selector: 'app-permission-error',
  template: `
    <app-public-layout>
      <div *ngIf="loaded">
        <p>{{message}}</p>
        <div class="nav-bar">
          <button *ngIf="hasRole" md-button (click)="location.back()">Go back</button>
          <button md-button *ngIf="auth.isAuthenticated()" (click)="auth.logout()">Log Out</button>
        </div>
      </div>
    </app-public-layout>
  `,
  styles: [`
    p, .nav-bar {
      text-align: center;
    }
    .nav-bar {
      margin-top: 20px;
    }
  `]
})
export class PermissionErrorComponent implements OnInit {
  message = 'You do not have permission to view this page.';

  loaded = false;
  hasRole = true;
  constructor(private currentUserService: CurrentUserService,
              public auth: AuthService,
              // location used in the template
              public location: Location) {}

  ngOnInit() {
    this.currentUserService.getCurrentUser().subscribe(user => {
      if (!this.userHasRole(user)) {
        this.message = 'dnata will need to assign you to a group before you can access the system. ' +
          'You will receive an email notification once you have been assigned a group.';
        this.hasRole = false;
      }

      this.loaded = true;
    });
  }

  /**
   * Returns a boolean value if the user has a role
   * @param user
   */
  userHasRole(user) {
    return user.roles.length > 0;
  }


}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/layout/components/permission-error/permission-error.component.ts